import Vue from 'vue';
import { TweenMax } from '@/vendor';

import Router from 'vue-router';

import Landing from '@/app/pages/Landing';
import Explain from '@/app/pages/Explain';
import Game from '@/app/pages/Game';
import Naw from '@/app/pages/Naw';
import Thanks from '@/app/pages/Thanks';

import Sanity from '@/app/pages/Sanity';

import store from '@/app/store';

Vue.use( Router );

var appRouter = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Landing',
            component: Landing,
            meta: {
                pageType: 'promotion-landing'
            }
        },
        {
            path: '/spel',
            name: 'Game',
            component: Game,
            meta: {
                pageType: 'promotion-content'
            },
            beforeEnter: ( to, from, next ) =>
            {
                if( !from.name )
                {
                    // next( '/' );
                }
                store.dispatch( 'game/resetValues' );
                next();
            },
            children: [
                {
                    path: 'uitleg',
                    name: 'Explain',
                    component: Explain,
                    meta: {
                        pageType: 'promotion-content'
                    }
                }
            ]
        },
        {
            path: '/gegevens',
            name: 'Naw',
            component: Naw,
            meta: {
                pageType: 'promotion-leadform'
            }
        },
        {
            path: '/bedankt',
            name: 'Thanks', // andere naam verzinnen
            component: Thanks,
            meta: {
                pageType: 'promotion-confirmation'
            }
        },
        {
            path: '/sanity',
            name: 'Sanity', // andere naam verzinnen
            component: Sanity,
            meta: {
                pageType: 'promotion-confirmation'
            }
        },
        {
            path: '/mail-base',
            name: 'LottoBase',
            component: Landing,
            beforeEnter: ( to, from, next ) =>
            {
                window._rootData.r = 'mail-base';
                store.dispatch( 'checkMailBase' );
                // next( '/' );
                next();
            },
            meta: {
                pageType: 'promotion-landing'
            }
        }
    ]
});

appRouter.beforeEach( ( to, from, next ) =>
{
    dataLayer.push({
        event: 'pageview',
        origin: 'website',
        type: to.meta.pageType,
        virtualPage: to.fullPath
    });

    if( typeof to.beforeEnter === 'function' ) // check if the route has a beforeEnter function
    {
        to.beforeEnter( to, from, next );
        return;
    }

    TweenMax.to( 'html,body', 0.15, { scrollTop: 0 });

    next();
});

export default appRouter;



// WEBPACK FOOTER //
// ./src/app/router.js